/**
 * 版本号判据单一源(0925 老板拍板,`docs/2026-09-25-版本号规划.md` §3)。
 *
 * ★为什么单独抽出这两个函数,不写在 WhatsNewDialog 里:
 *   「MINOR 才弹更新记录」这条规矩以后任何要读版本号的地方(强提醒、红点、帮助中心)都得
 *   照同一个判据来,写两份迟早有一份漏改成「PATCH 也弹」。
 */

/** "1.1.3" → "1.1";版本号段数不足两段时原样返回(不在这里猜兜底策略)。 */
export function minorOf(version: string): string {
  const parts = version.split(".");
  if (parts.length < 2) return version;
  return `${parts[0]}.${parts[1]}`;
}

/**
 * 只在跨 MINOR 时才弹「本次更新」——同 MINOR 的 PATCH 升级(缺陷/欠账/小功能,发版车自行
 * 递增)不弹,弹了等于每天骚扰用户。
 *
 * ★`lastSeen` 为空(首次登录)不归这个函数管:调用方走「新手指引」分支,统一按 `false` 处理,
 *   不在这里判断——首次登录该弹的是欢迎语,不是更新清单,那条判断在 `WhatsNewDialog` 里。
 */
export function shouldShowWhatsNew(lastSeen: string | null | undefined, latest: string): boolean {
  if (!lastSeen) return false;
  return minorOf(lastSeen) !== minorOf(latest);
}
